module.exports = __webpack_public_path__ + "static/media/landing_desktop.0c9854a2.jpg";